import React from "react";
import { FormProps } from "./props";
import TextEntry from "../../molecules/TextEntry";
import Button from "../../atoms/Button";
import Header from "../../atoms/Title";
import Subtitle from "../../atoms/Subtitle";
import Disclaimer from "../../atoms/ListSection";
import Spacer from "../../atoms/Spacer";
import Footer from "../../molecules/Footer";
import Logo from "../../atoms/Logo";
import TextEntryProps from "../../molecules/TextEntry/props";

const Form = ({
  fields,
  submit,
  title,
  subTitle,
  disclaimer,
  handleChange,
  handleSubmit,
}: FormProps) => {
  return (
    <div className={"vcl-form-container"}>
      <Logo type={"default"} />
      <Spacer style={{ height: "32px" }} />
      <Header properties={{ children: title }} />
      <Subtitle properties={{ children: subTitle }} />
      <Spacer />
      <form className={"vcl-form-element"}>
        {fields?.map((field: TextEntryProps, index: number) => (
          <TextEntry
            key={index}
            details={field?.details}
            label={field?.label}
            input={{
              onChange: handleChange,
              ...field?.input,
            }}
          />
        ))}
        <Button label={submit} type={"button"} onClick={handleSubmit} />
      </form>
      <Spacer />
      <Disclaimer html={disclaimer ?? []} />
      <Footer />
    </div>
  );
};

export default Form;
